<template>
  <div class="overflow-auto">
    <h2 class="font-bold text-18px pb-0.5">Analytics</h2>
    <template v-if="dataSetObj.set">
      <LineChart
        :loading="loading"
        :period="period"
        :dataSetObj="dataSetObj"
        :dataSetComparedObj="dataSetComparedObj"
        @update:periodDate="handlePeriodDateChange"
        @update:compareDate="handleCompareDateChange"
      />

      <CreativeTable :creatives="creativeData" />
    </template>
    <NoDataCard v-loading="loading" v-else>
      <template slot="title">Analytics not available yet</template>
      <template slot="info">Analytics will be available once the campaign is active.</template>
    </NoDataCard>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import NoDataCard from '@/components/social-products/social-boost/parts/NoDataCard.vue'
import LineChart from '@/components/social-products/social-boost/parts/Report/LineChart.vue'
import CreativeTable from '@/components/social-products/social-boost/parts/Report/CreativeTable.vue'
import AnalyticsMixin from '@/mixins/social-products/Analytics.js'

export default {
  mixins: [AnalyticsMixin],
  components: {
    NoDataCard,
    LineChart,
    CreativeTable,
  },
  data() {
    return {
      loading: false,
      period: {},
      dataSet: false,
      xaxis: [],
      creativeData: [],
      dataSetObj: {
        set: false,
        xaxis: [],
      },
      dataSetComparedObj: {
        set: false,
        xaxis: [],
      },
    }
  },
  created() {
    this.getDataForChart()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
  },
  methods: {
    async getDataForChart(selectedDate = false) {
      this.loading = true
      try {
        const flight = this.$route.params.flight_id ? '?flight=' + this.$route.params.flight_id : ''
        const { data } = await this.axios.get(`/api/social-products/social-boost/analytics/${this.$route.params.id}${flight}`, {
          params: selectedDate ? selectedDate : this.period,
        })

        if (!selectedDate) {
          this.dataSetObj = {
            set: this.extractDataset(data.lineItemStats),
            xaxis: this.extrageDateUnice(data.lineItemStats),
          }

          this.period = {
            start_date: data?.startDate,
            end_date: data?.endDate,
          }

          this.creativeData = data.creativeStats
        } else {
          const dataSetCompared = {
            set: this.extractDataset(data.lineItemStats),
            xaxis: this.extrageDateUnice(data.lineItemStats),
          }

          this.dataSetComparedObj = this.alignFullComparisonData(this.dataSetObj.xaxis.impressions, dataSetCompared)
        }
      } catch (error) {
        console.error('Failed to fetch chart data:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
